module.exports = __webpack_public_path__ + "img/wechat.21c3c911.svg";